import React from 'react';
import { Redirect, Route, RouteProps, RouteComponentProps } from "react-router-dom";

export interface ProtectedRouteProps extends RouteProps {
    hasPermission: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

export default function ProtectedRoute(props: ProtectedRouteProps): JSX.Element {
    const { hasPermission, component: Component, ...rest } = props;
    return (
        <Route {...rest} render={(props) => {
            return hasPermission
                ? <Component {...props} />
                : <Redirect to='/login' />
        }} />
    )
}
